<template>
  <div class="relative">
    <el-progress
      type="circle"
      :percentage="lots * 5"
      :format="format"
      color="#0051ff"
      :show-text="false"
      :width="width"
      :stroke-width="15"
    ></el-progress>
    <div class="absolute">
      <div class="black-text" :class="{ grey: status !== 'OI' }">{{ $t('common.handAmount') }}</div>
      <div class="blue-text" :class="{ grey: status !== 'OI' }">
        {{ lots ? lots.toFixed(2) : (0).toFixed(2) }}/{{ limit.toFixed(2) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromotionProgress',
  props: {
    status: '',
    lots: {
      type: Number,
      default: 0
    }
  },
  data() {
    return { limit: 20 };
  },
  computed: {
    width() {
      let progressWidth = 450;
      if (window.innerWidth < 450) progressWidth = 320;
      return progressWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
.relative {
  padding: 60px 0;
  position: relative;
  .absolute {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: Oblivian-Bold;
    width: max-content;

    .grey {
      color: $gray !important;
    }

    .black-text {
      color: $broker-black;
      font-size: 32px;
    }

    .blue-text {
      color: $primary-blue;
      font-size: 64px;

      @media (max-width: $DEVICE_SIZE_MOBILEL) {
        font-size: 40px;
      }

      @media (min-width: $DEVICE_SIZE_TABLET) {
        font-size: 55px;
      }
    }
  }
}
</style>
